// extracted by mini-css-extract-plugin
module.exports = {"list-template":"ListTemplate_list-template__2me9X","title__container":"ListTemplate_title__container__1nWbM"};